module.exports = __webpack_public_path__ + "static/logo-4033c953ca5e52a00898a16f065a46a9.png";